import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6c60a5bd&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CReset: require('@chakra-ui/vue').CReset, CHeading: require('@chakra-ui/vue').CHeading, CText: require('@chakra-ui/vue').CText, CLink: require('@chakra-ui/vue').CLink, CListItem: require('@chakra-ui/vue').CListItem, CList: require('@chakra-ui/vue').CList, CBox: require('@chakra-ui/vue').CBox, CFlex: require('@chakra-ui/vue').CFlex, CThemeProvider: require('@chakra-ui/vue').CThemeProvider})
